"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation createCollectionModel($collectionModel: CollectionModelInput!) {
        createCollectionModel(input: { collectionModel: $collectionModel }) {
            collectionModel {
                corpCollectionId
                corpCollectionModelId
                modelNumber
            }
        }
    }
`;exports.createCollectionModel=e;
//# sourceMappingURL=queries.js.map
